import { Grid } from '@mui/material';
import { Control, useWatch } from 'react-hook-form';
import { AppBox } from '../../components/AppBox';
import { AppFieldProps } from '../../types/components.type';
import { AppTextField } from '../../components/AppTextField';
import { ValidationUtils } from '../../utils/validations.utils';

type GroupRoutineFieldProps = {
    control: Control<any>;
} & AppFieldProps;

export default function GroupRoutineField(props: GroupRoutineFieldProps) {
    const { control } = props;

    const isGroupRoutine: any = useWatch({
        control,
        name: 'is_single_station',
        defaultValue: control._formValues['is_single_station'] || false,
    });

    if (!isGroupRoutine) {
        // Other kind of exercise type that doesn't need this configurations
        return <></>
    }

    return (
        <AppBox>
            <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                    <AppTextField
                        name='workout_single_station.exercises_count'
                        control={control}
                        label='Number of Exercises'
                        rules={
                            {
                                validate: ValidationUtils.isInteger
                            }
                        }
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <AppTextField
                        name='workout_single_station.exercises_duration'
                        control={control}
                        label='Exercise Duration (s)'
                        rules={
                            {
                                validate: ValidationUtils.isInteger
                            }
                        }
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <AppTextField
                        name='workout_single_station.exercises_rest'
                        control={control}
                        label='Rest (s)'
                        rules={
                            {
                                validate: ValidationUtils.isInteger
                            }
                        }
                    />
                </Grid>
            </Grid>
        </AppBox>
    );
}
